import { SP_HEADER_EVENTS } from 'Utilities/analytics/analyticsHeader';
import { MOTORWAY_URL } from 'Utilities/urls';

export const handleLogoutClick = async (e:React.MouseEvent) => {
  e.preventDefault();
  SP_HEADER_EVENTS.HEADER_LINK_CLICKED({
    name: 'sign_out',
    url: MOTORWAY_URL,
  });
};
